import React from 'react';

import { RenderLeafProps } from 'slate-react';

function Leaf({ attributes, children, leaf }: Partial<Omit<RenderLeafProps, 'leaf'>> & { leaf: any }) {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
}

export default Leaf;
